module.exports = __webpack_public_path__ + "img/Alonso_Tovar.2892fe58.webp";